import { render, staticRenderFns } from "./IconCompetencyCriteria.vue?vue&type=template&id=5317e578"
import script from "./IconCompetencyCriteria.vue?vue&type=script&lang=js"
export * from "./IconCompetencyCriteria.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports